import { render } from "./DaysRemaining.vue?vue&type=template&id=238a6331&scoped=true"
import script from "./DaysRemaining.vue?vue&type=script&lang=js"
export * from "./DaysRemaining.vue?vue&type=script&lang=js"

import "./DaysRemaining.vue?vue&type=style&index=0&id=238a6331&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238a6331"]])

export default __exports__